import { getData, patchData } from '../utils/db'

export type TTenantSettings = {
    /** Minutes a finished import, conversion or export stays visible. */
    taskRetentionMinutes: number
    /** Minutes a password reset link lasts — for everybody, set by an administrator. */
    resetLinkMinutes: number
    /** Hours a checked but unsaved upload stays on the server — for everybody, set by an administrator. */
    uploadRetentionHours: number
}

/**
 * Settings of the signed-in user's tenant.
 *
 * A project may override individual values; the effective one is resolved on the
 * server (services/settings) so both sides cannot drift apart.
 */
export default class SettingsModel {
    public async read(): Promise<{ data: TTenantSettings } | undefined> {
        return await getData('/settings')
    }

    public async update(changes: Partial<TTenantSettings>) {
        return await patchData('/settings', changes)
    }
}
